export class LgaDto {
  id: string;
  SiteId: string;
  ModifiedById: string;
  CreatedById: string;
  dateUpdated: Date;
  dateCreated: Date;
  Version: number;
  LgaName: string;
  Abbreviation: string;
  SubscriberEmail: string;
  StateId: string;
  SubscriberId: string;
  SubscriptionUserId: string;
  }
